export const SMART_EDITS_SUMMARY_DATA_API_URL = 'smart-edits/summary';
export const SMART_EDITS_SUMMARY_DATA_API_BULK_URL = 'smart-edits-job/summary';
export const SMART_EDIT_STATUS_DATA_API_URL = 'smart-edits/status';
export const SMART_EDIT_STATUS_DATA_API_BULK_URL = 'smart-edits-job/status';
export const SMART_EDIT_TOP_REASONS_DATA_API_URL = 'smart-edits/top-reasons';
export const SMART_EDIT_TOP_REASONS_DATA_API_BULK_URL = 'smart-edits-job/top-reasons';
export const SMART_EDIT_OVER_TIMES_DATA_API_URL = 'smart-edits/over-time?requestType=';
export const SMART_EDIT_OVER_TIMES_DATA_API_BULK_URL = 'smart-edits-job/over-time?requestType=';
export const SMART_EDIT_TOP_CLAIM_DATA_API_URL='smart-edits/top-claims';
